import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import { getAllResearchAction } from '../../Redux/Actions/ResearchAction';

import ProjectCard from '../ProjectCard/ProjectCard';
import './HResearchSection.css';

const HResearchSection = () => {

    const dispatch = useDispatch()
    const isLoading = useSelector((e) => e?.LoadingReducer?.isLoading)
    const researchList = useSelector((e) => e?.ResearchReducer?.researchList)

    useEffect(() => {
        getDetails()
    }, [])

    const getDetails = () => {
        dispatch(getAllResearchAction())
    }

    const visibleResearch = researchList.slice(0, 4);

    return (
        <section className='hresearch-section'>

            <div className="container pb-5 pt-5">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-4 text-primary fw-bold border-start border-4 ps-2">Research</h5>
                    <Link to="/research/researchProject" className="text-decoration-none text-primary fw-semibold">View More →</Link>
                </div>
                {
                    isLoading ?
                        <div className='text-center'>
                            <Spinner animation="border" />
                        </div>
                        :
                        <div className="row g-4">
                            {
                                visibleResearch.map((item, index) => (
                                    <div className="col-12 col-sm-6 col-md-3" key={index}>
                                        <div className="card research-card h-100">
                                            <ProjectCard
                                                src={`https://api.coeupdspadelhi.in/uploads/${item?.image}`}
                                                params={item}
                                                path={`research/researchProject/${item?.title}`}
                                                title={item.title}
                                            />
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                }
            </div>
        </section>
    );
};

export default HResearchSection;